{
  "anwb-energie": {
    "url": "https://glp8.net/c/?si=21989&li=1927025&wi=415699&ws=anwb-energie&dl=energie",
    "network": "daisycon",
    "campaign_id": "21989",
    "campaign": "ANWB Energie"
  },
  "budget-energie": {
    "url": "https://dc.budgetthuis.nl/c/?si=9946&li=1444680&wi=415699&ws=budget-energie&dl=energie",
    "network": "daisycon",
    "campaign_id": "9946",
    "campaign": "Energie van Budget Thuis"
  },
  "coolblue-energie": {
    "url": "https://www.awin1.com/cread.php?awinmid=85163&awinaffid=2673030&clickref=coolblue-energie&clickref2=epexprijzen-nl&ued=https%3A%2F%2Fwww.coolblue.nl%2Fenergie&platform=pl",
    "network": "awin",
    "campaign_id": "85163",
    "campaign": "Coolblue Energie NL"
  },
  "delta-energie": {
    "url": "https://lt45.net/c/?si=12110&li=1910982&wi=415699&ws=delta-energie&dl=stroom-gas%2Fdynamisch-energiecontract%2F",
    "network": "daisycon",
    "campaign_id": "12110",
    "campaign": "DELTA Energie"
  },
  "easyenergy": {
    "url": "https://glp8.net/c/?si=19921&li=1848248&wi=415699&ws=easyenergy&dl=dynamische-energie",
    "network": "daisycon",
    "campaign_id": "19921",
    "campaign": "easyEnergy"
  },
  "energie-vanons": {
    "url": "https://partner.energie.vanons.org/c?c=39364&m=12&a=514268&r=energie-vanons&u=",
    "network": "tradetracker",
    "campaign_id": "39364",
    "campaign": "energie.vanons.org"
  },
  "energiedirect": {
    "url": "https://lt45.net/c/?si=924&li=55221&wi=415699&ws=energiedirect&dl=energie%2Fenergiecontract%2Fdynamisch",
    "network": "daisycon",
    "campaign_id": "924",
    "campaign": "energiedirect"
  },
  "energiek": {
    "url": "https://partner.energiek.nl/c?c=39778&m=12&a=514268&r=energiek&u=%2Fenergie%2Fdynamisch",
    "network": "tradetracker",
    "campaign_id": "39778",
    "campaign": "Energiek.nl"
  },
  "energyzero": {
    "url": "https://d.energyzero.nl/c/?si=20943&li=1892250&wi=415699&ws=energyzero&dl=",
    "network": "daisycon",
    "campaign_id": "20943",
    "campaign": "Energyzero (NL)"
  },
  "essent": {
    "url": "https://lt45.net/c/?si=9787&li=1437653&wi=415699&ws=essent&dl=",
    "network": "daisycon",
    "campaign_id": "9787",
    "campaign": "Essent"
  },
  "frank-energie": {
    "url": "https://jf79.net/c/?si=16978&li=1731992&wi=415699&ws=frank-energie&dl=",
    "network": "daisycon",
    "campaign_id": "16978",
    "campaign": "Frank Energie (NL)"
  },
  "frank-energie-slim": {
    "url": "https://jf79.net/c/?si=16978&li=1731992&wi=415699&ws=frank-energie-slim&dl=",
    "network": "daisycon",
    "campaign_id": "16978",
    "campaign": "Frank Energie (NL)"
  },
  "groenpand": {
    "url": "https://analytics.groenpand.nl/c?c=40779&m=12&a=514268&r=groenpand&u=%2Fgroene-stroom-en-gas",
    "network": "tradetracker",
    "campaign_id": "40779",
    "campaign": "Groenpand.nl"
  },
  "innova": {
    "url": "https://fr135.net/c/?si=15501&li=1670745&wi=415699&ws=innova&dl=",
    "network": "daisycon",
    "campaign_id": "15501",
    "campaign": "Innova"
  },
  "nextenergy": {
    "url": "https://partners.nextenergy.nl/c/?si=17689&li=1765747&wi=415699&ws=nextenergy&dl=",
    "network": "daisycon",
    "campaign_id": "17689",
    "campaign": "NextEnergy"
  },
  "powerpeers": {
    "url": "https://lt45.net/c/?si=12400&li=1544330&wi=415699&ws=powerpeers&dl=dynamische-energie%2Fhelemaal-dynamisch-energiecontract%2F",
    "network": "daisycon",
    "campaign_id": "12400",
    "campaign": "Powerpeers"
  },
  "samenom": {
    "url": "https://affiliate.samenom.nl/c?c=36113&m=12&a=514268&r=samenom&u=%2Fdynamische-overeenkomst%2F",
    "network": "tradetracker",
    "campaign_id": "36113",
    "campaign": "om | nieuwe energie"
  },
  "vandebron": {
    "url": "https://lt45.net/c/?si=12134&li=1535052&wi=415699&ws=vandebron&dl=",
    "network": "daisycon",
    "campaign_id": "12134",
    "campaign": "Vandebron"
  },
  "vattenfall": {
    "url": "https://lt45.net/c/?si=2036&li=119986&wi=415699&ws=vattenfall&dl=energie%2Fdynamisch-energiecontract%2F",
    "network": "daisycon",
    "campaign_id": "2036",
    "campaign": "Vattenfall"
  }
}
